import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { InitUser, loginViaAuth0, retrieveCachedUserDetails } from '../../thunks/session_thunks';
import { skipTokenCheck } from '../../actions/session_actions';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router';
import { getUserTypeFromURL } from '../../utils/HistoryUtils';
import { CURRENT_ENV_ROLE_TYPE } from '../../utils/EnvConfigUtils';

const LoginWrapper = ({ store, children, isLoggedIn, currentUser, isActive, isApproved }) => {
	const auth0 = useAuth0();
	const location = useLocation();
	const { isAuthenticated: isAuth0Authenticated, isLoading, logout } = auth0;

	const { token, userType = 'buyer' } = retrieveCachedUserDetails(['token', 'userType']);

	const userTypeFromUrl = getUserTypeFromURL(location);
	// Effect to renew the token every 6 hours

	const finalUserType = userType || userTypeFromUrl || CURRENT_ENV_ROLE_TYPE;

	useEffect(() => {
		async function fetchData() {
			const claims = await auth0.getIdTokenClaims();
			store
				.dispatch(loginViaAuth0(finalUserType, claims.__raw, claims))
				.then(console.log)
				.catch(() => {
					// this says login wth SSO was success but failed on OW API , this will mean that SSO sdk will considered user logged in but our system wont. logging out user form sso also, so that they can retry.
					// this cpuld be called on landing where user is not completely identified.
					logout({
						logoutParams: {
							returnTo: `${window.location.origin}/${finalUserType || CURRENT_ENV_ROLE_TYPE}/login`,
						},
					});
				});
		}
		//  this is app level wrapper
		// first, wait for Auth0 loading to finish fetching details
		// check if the user is authenticated on SSO -> get the token and pass it to backend to validate and then store it in localstorage
		// if not, check if there is already a token in localStorage -> get it renewed from backend and store new token in localstorage
		// else, user is not auth either via SSO or OW . mark user loggedIn false

		if (!isLoading) {
			if (isAuth0Authenticated) {
				fetchData();
			} else if (token) {
				// @ts-ignore
				store.dispatch(InitUser(finalUserType, window.location.search));
			} else {
				store.dispatch(skipTokenCheck());
			}
		}
	}, [isLoading]);

	return children;
};

const mapStateToProps = (state) => ({
	isLoggedIn: state.session.isAuthenticated,
	currentUser: state.session.currentUser,
	isActive: state.session.isActive,
	isApproved: state.session.isApproved,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWrapper);
